export const componentWhiteList = new Set([
  'PageSectionContent',
]);
